//! DO NOT EDIT THIS FILE IT IS GENERATED USING:
// mgs generate-flags

// Default On Variation: true
// Default Off Variation: false
export const FF_SUPPLIER_SHOPIFY_ORDERS = 'supplier_shopify_orders';

// Default On Variation: 5
// Default Off Variation: 0
export const FF_APHRA_MAX_UPLOAD_SIZE_MB = 'APHRA_MAX_UPLOAD_SIZE_MB';

// Default On Variation: 5
// Default Off Variation: 0
export const FF_APPROVAL_MAX_FILE_SIZE_MB = 'APPROVAL_MAX_FILE_SIZE_MB';

// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACIST_NEW_EXPERIENCE_CHECKOUT = 'pharmacist_new_experience_checkout';

// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACIST_NEW_EXPERIENCE_ORDERS = 'pharmacist_new_experience_orders';

// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACIST_NEW_EXPERIENCE = 'pharmacist_new_experience';

// Default On Variation: true
// Default Off Variation: false
export const FF_SHIPMENTS_EXPORT = 'shipments_export';

// Default On Variation: true
// Default Off Variation: false
export const FF_USE_CART_LOADER = 'use_cart_loader';

// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACIST_ARCHIVE_MODE = 'pharmacist_archive_mode';

// Default On Variation: 2
// Default Off Variation: 0
export const FF_BULK_CART_MAX_UPLOAD_SIZE_MB = 'BULK_CART_MAX_UPLOAD_SIZE_MB';

// Default On Variation: true
// Default Off Variation: false
export const FF_LEAFIO_CLASSIC_REGISTRATION = 'leafio_classic_registration';

// Description: Stores the google maps api keys for the storefront, avoiding to include them in the codebase
// Default On Variation: {"local":"local","prod":"prod","stg":"stg"}
// Default Off Variation: {"local":"local","placeholder":"placeholder value","prod":"prod","stg":"stg"}
export const FF_GOOGLEMAPS_CLIENT_APIKEY = 'googlemaps_clientAPIkey';

// Description: MVP for returns (B2B-3853)
// Default On Variation: true
// Default Off Variation: false
export const FF_RETURN_ITEMS = 'return_items';

// Description: When enabled, unsubscribes braze users who are unsubscribed in Shopify.
// Default On Variation: true
// Default Off Variation: false
export const FF_BRAZE_UNSUBSCRIBE_USERS = 'braze_unsubscribe_users';

// Description: Used for unit testing purposes
// Default On Variation: true
// Default Off Variation: false
export const FF_TEST_FLAG = 'test_flag';

// Description: Turns on snowplow tracking for leafio front end app
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_SNOWPLOW = 'enable_snowplow';

// Description: Use to enable Bulk Discounts in Leafio storefront.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_BULK_DISCOUNTS = 'enable_bulk_discounts';

// Default On Variation: true
// Default Off Variation: false
export const FF_CONSIGNMENTS_LIST = 'consignments_list';

// Description: Use to enable discounts sync with Selly before the checkout
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_DISCOUNTS_SYNC = 'enable_discounts_sync';

// Description: Epic B2B-6155. Enable loyalty transaction import functionality to show up in Admin
// Default On Variation: true
// Default Off Variation: false
export const FF_LOYALTY_IMPORT = 'loyalty_import';

// Description: Epic B2B-6155. Manages the Loyalty Rewards feature on the Leafio Storefront.
// Default On Variation: true
// Default Off Variation: false
export const FF_LOYALTY = 'loyalty';

// Description: When true, will display the shipping notification when users meet the criteria. Displayed in the cart drawer and the cart page.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_SHIPPING_NOTIFICATION = 'enable_shipping_notification';

// Description: New feature to manage one to many supplier users on the new warehousing APIs
// Default On Variation: true
// Default Off Variation: false
export const FF_ADMIN_SUPPLIER_MULTI_USERS = 'admin_supplier_multi_users';

// Description: Ability to cancel partial fulfilled orders in Admin
// Default On Variation: true
// Default Off Variation: false
export const FF_ADMIN_PARTIAL_ORDER_CANCELLATION = 'admin_partial_order_cancellation';

// Description: New supplier portal. Redirects the old supplier portal (leafio-classic) to the new version
// Default On Variation: true
// Default Off Variation: false
export const FF_NEW_SUPPLIER_PORTAL = 'new_supplier_portal';

// Description: Epic B2B-6155. Controls to display the Import loyalty profiles action in the Shopify Admin portal
// Default On Variation: true
// Default Off Variation: false
export const FF_LOYALTY_PROFILE_IMPORT = 'loyalty_profile_import';

// Description: Epic B2B-6155. Enables displaying the loyalty option in admin
// Default On Variation: true
// Default Off Variation: false
export const FF_ADMIN_LOYALTY_VIEW = 'admin_loyalty_view';

// Description: Spike B2B-6976. Enable Leafio to proxy 3rd party domain through us. This is to address problem with some pharmacies blocking certain
// website. Also see https://montugroup.atlassian.net/browse/B2B-7159. - For production, we only want it to affect Chemist Warehouse, and some Chemist
// Warehouse uses that don't use the normal email domain. - For staging, I am adding 2 domains for testing that it behaves the same as production.
// Default On Variation: true
// Default Off Variation: false
export const FF_LEAFIO_PROXY = 'leafio_proxy';

// Description: Enables V2 of the cart loader functionality that does not consolidate products into one order item on load.
// Default On Variation: true
// Default Off Variation: false
export const FF_CART_LOADER_V2_ENABLED = 'cart_loader_v2_enabled';

// Description: EPIC B2B-7053: Used to control the A/B testing for the new registration form.
// Default On Variation: Control
// Default Off Variation: Control
export const FF_NEW_REGISTRATION_FORM = 'new_registration_form';

// Description: Use to show/hide the "About Leafio Loyalty" tab on the loyalty page
// Default On Variation: true
// Default Off Variation: false
export const FF_ABOUT_LEAFIO_LOYALTY = 'about_leafio_loyalty';

// Description: Enables the Cloudflare Turnstile widget in Leafio Node. This is currently being used on the New Registration Form.
// Default On Variation: true
// Default Off Variation: false
export const FF_CLOUDFLARE_TURNSTILE = 'cloudflare_turnstile';

// Description: Enables the new order details page implementation that uses the Wholesale Order API as the source of truth.
// Default On Variation: true
// Default Off Variation: false
export const FF_ORDER_DETAILS_REWORK = 'order_details_rework';

// Description: B2B-7682: When enabled, will display the Tab Navigation on the Collections Page with "Top Picks", and the route will be navigable.
// Default On Variation: true
// Default Off Variation: false
export const FF_TOP_PICKS = 'top_picks';

// Description: B2B-7934: When enabled, this applies the new brand and product-based MOQ rules. When disabled, it will use the MOQ values from product
// metafields instead.
// Default On Variation: true
// Default Off Variation: false
export const FF_MOQ_RULES = 'moq_rules';

// Description: When enabled show the search button on the product list page, when disabled use the search-as-you-type method.
// Default On Variation: true
// Default Off Variation: false
export const FF_PLP_MANUAL_SEARCH = 'plp_manual_search';

// Description: Enables V2 of the returns form where resolution is handled separately to other status updates.
// Default On Variation: true
// Default Off Variation: false
export const FF_RETURNS_FORM_V2 = 'returns_form_v2';

// Description: Revised shipments table with invoice pay button
// Default On Variation: true
// Default Off Variation: false
export const FF_SHIPMENTS_V2 = 'shipments_v2';

// Description: Enables the alternative invoice PDF template that includes a pay now button
// Default On Variation: true
// Default Off Variation: false
export const FF_WHOLESALE_INVOICE_PAY_NOW_PDF_TEMPLATE = 'wholesale_invoice_pay_now_pdf_template';

// Description: Enables displaying delivery estimates at product/cart level
// Default On Variation: true
// Default Off Variation: false
export const FF_DELIVERY_ESTIMATES = 'delivery_estimates';

// Description: Enables the alternate view in the cart for shipment estimates and breakdown
// Default On Variation: true
// Default Off Variation: false
export const FF_CART_DELIVERY_ESTIMATES = 'cart_delivery_estimates';

// Description: When enabled, the delivery estimate shown in the cart is stored on the cart as a metafield so it is copied onto the order for accuracy
// analysis.
// Default On Variation: true
// Default Off Variation: false
export const FF_STORE_CART_DELIVERY_ESTIMATE = 'store_cart_delivery_estimate';

// Description: Displays the product and brand MOQ alert in the PDP.
// Default On Variation: true
// Default Off Variation: false
export const FF_DISPLAY_MOQ_PDP = 'display_moq_pdp';

// Description: https://montugroup.atlassian.net/jira/polaris/projects/SPO/ideas/view/a82fdaa1-90e5-43dc-9fa2-9532f4698c01?selectedIssue=SPO-5
// Default On Variation: true
// Default Off Variation: false
export const FF_SHIPMENTS_BULK_PAYMENT = 'shipments_bulk_payment';

// Default On Variation: true
// Default Off Variation: false
export const FF_BUNDLE_FEATURE = 'bundle_feature';

// Description: Enables the bundle creation functionality in Leafio Shopify admin app
// Default On Variation: true
// Default Off Variation: false
export const FF_ADMIN_CREATE_PRODUCT_BUNDLE = 'admin_create_product_bundle';

// Description: PD-2185: When enabled, shows the Frequently Purchased carousel on the collections page instead of Top Picks.
// Default On Variation: true
// Default Off Variation: false
export const FF_FREQUENTLY_PURCHASED = 'frequently_purchased';

// Description: This will enable the bottom left side bar banner in Loyalty page in accounts section
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_SIDE_BAR_BANNER_IN_LOYALTY_PAGE = 'enable_side_bar_banner_in_loyalty_page';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_TOP_BANNER_IN_ACCOUNT_PAGE = 'enable-top-banner-in-account-page';

// Description: Enable the banner in the cart page
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_BANNER_IN_CART_PAGE = 'enable_banner_in_cart_page';

// Description: PD-2363: Shows patient details (name and date of birth) alongside the doctor name in the TGA approval document select.
// Default On Variation: true
// Default Off Variation: false
export const FF_APPROVAL_PATIENT_DETAILS = 'approval_patient_details';

// Description: Enable the banner carousel and filter sidebar banner on the products page
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_CAROUSEL_BANNER_IN_PRODUCTS_PAGE = 'enable_carousel_banner_in_products_page';
